import { fetchPlugins } from '@/core/api/plugins'
import { CLEAR_STATE, END_REQUEST, SET_STATE, START_REQUEST } from './mutation-types'

export default {
  namespaced: true,
  state: {
    loading: false,
    items: [],
  },
  actions: {
    async FETCH({ commit }) {
      commit(START_REQUEST)
      commit(SET_STATE, await fetchPlugins())
      commit(END_REQUEST)
    },
  },
  mutations: {
    [START_REQUEST]: state => {
      state.loading = true
    },
    [END_REQUEST]: state => {
      state.loading = false
    },
    [CLEAR_STATE]: state => {
      state.items = []
    },
    [SET_STATE]: (state, items) => {
      state.items = items
      state.loading = false
    },
  },
}
